import axiosInstance from "../services/axiosInstance";

export const registerCompany = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/organization/register",
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};

// fetchRegisterSuggestions("ID") → preset per kode negara;
// fetchRegisterSuggestions({ countryId }) → preset untuk negara organisasi (id tabel countries),
// sudah termasuk mata uang & zona waktu — dipakai form /get-started.
export const fetchRegisterSuggestions = async (country = "") => {
  const params =
    country && typeof country === "object"
      ? { country_id: country.countryId }
      : country
        ? { country_code: country }
        : {};

  try {
    const response = await axiosInstance.get(
      "console/organization/suggestions",
      { params },
    );

    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};

// Status langkah penting dashboard: jumlah template jadwal & payroll, karyawan,
// dan karyawan yang sudah login di aplikasi mobile.
export const fetchOnboardingStatus = async (companyId) => {
  try {
    const response = await axiosInstance.get(
      "console/organization/onboarding-status",
      { params: { company_id: companyId } },
    );

    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};

export const updateCompany = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/organization/update",
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};

export const getSettings = async (companyId) => {
  try {
    const response = await axiosInstance.get("console/organization/settings", {
      params: {
        company_id: companyId,
      },
    });

    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};
